import React from 'react';
import * as helpers from './helpers';

const GoogleIcon = props => (
  <svg
    {...helpers.getSvgDimensionsProps(props)}
    {...props}
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.273 15c0-.953.161-1.866.45-2.723L1.675 8.503A14.41 14.41 0 00.136 15c0 2.335.554 4.538 1.537 6.493l5.045-3.782A8.514 8.514 0 016.273 15z"
      fill="#FBBC05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.136 6.333c2.114 0 4.023.734 5.523 1.934L25.023 4C22.363 1.733 18.955.333 15.136.333c-5.927 0-11.022 3.32-13.461 8.17l5.048 3.774c1.163-3.457 4.479-5.944 8.413-5.944z"
      fill="#EA4335"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.136 23.667c-3.934 0-7.25-2.487-8.413-5.944l-5.048 3.774c2.44 4.85 7.534 8.17 13.461 8.17 3.659 0 7.152-1.272 9.774-3.656l-4.792-3.627c-1.352.834-3.055 1.283-4.982 1.283z"
      fill="#34A853"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.455 15c0-.867-.137-1.8-.341-2.667H15.136V18h8.046c-.402 1.932-1.497 3.417-3.064 4.384l4.792 3.627c2.753-2.502 4.545-6.23 4.545-11.011z"
      fill="#4285F4"
    />
  </svg>
);

GoogleIcon.propTypes = {
  ...helpers.iconDimensionsPropTypes,
};

GoogleIcon.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(30, 30),
  ...helpers.getViewBoxProperty({ width: 30, height: 30 }),
};

export default GoogleIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/google.js